import {DateFilter} from '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import {html} from "@isceco/widget-library2/external/lit";

export default class SingleDateFilter extends DateFilter {

  renderIndicator = () => {
    if (isEmpty(this.displayedValue.to)) {
      return html`
        <div class="filter-indicator filter-range-indicator"
             @click="${this._showPopup}"
             @keydown="${this._checkOpenPopup}"
             tabindex="0"
             title="${this.label}">
          <span class="label">${this.label}</span>
          <i class="angle down icon"></i>
        </div>
      `
    } else {
      const text = `${this.label}: ${isEmpty(this.displayedValue.to) ? '' : formatDate(this.displayedValue.to)}`

      return html`
        <div class="filter-indicator filter-indicator-selected"
             @click="${this._showPopup}"
             @keydown="${this._checkOpenPopup}"
             tabindex="0"
             title="${text}">
          <span class="label">${text}</span>
          <i class="icon times"
             @click="${e => {
        this._clear(true)
        e.stopPropagation()
      }}"></i>
        </div>
      `
    }
  }

  renderDateSelectors = () => {
    return html`
      <label class="date-input">
        <span>${translateText(this._translations(), 'dateTo')}</span>
        <input type="date"
               class="end-date"
               title=" "
               min="${this.min}"
               max="${this.getMax()}"
               .value="${this.value.to}"
               @blur="${this._sendChange}"
               @change="${this._setEndDate}">
      </label>
    `
  }
}
customElements.define('eko-single-date-filter', SingleDateFilter)
